var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"main"},[_c('div',{staticClass:"container"},[_c('header-tabs',{staticClass:"user-settings-nav mt-3 has-icons",attrs:{"content":_vm.headerTabs,"activeTab":_vm.activeTab}}),(_vm.$route.name === 'settings')?[_c('the-settings')]:_vm._e(),_c('router-view')],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }